import { Text } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import { COLOR, COLOR_TOKEN } from '../../../constant-styles';

export const AnimatedCardWrapper = styled.div<{
	isActive: boolean;
	ofertasNumber: number;
}>`
	padding: var(--size-dynamic0050) var(--size-dynamic0100);
	background-color: ${COLOR.WHITE_75};
	backdrop-filter: blur(10px);
	border: 2px solid
		${(props) => (props.isActive ? `${COLOR_TOKEN.focus.main}` : 'transparent')};
	border-radius: 10px;
	overflow: hidden;
	transition: border-color 0.2s ease;
	display: flow-root;
	cursor: ${(props) => (props.isActive ? 'default' : 'pointer')};

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		// Cards en horizontal
		flex: 1 1 0;
	}

	${(props) =>
		!props.isActive &&
		props.ofertasNumber > 1 &&
		`
			&:hover {
				border: 2px solid ${COLOR_TOKEN.border.default};
			}
	`}
`;

export const TwoColumnsDiv = styled.div<{
	isActive: boolean;
	ofertasNumber: number;
}>`
	display: grid;
	grid-template-columns: ${(props) =>
		props.isActive || props.ofertasNumber === 1
			? '1fr max-content'
			: '1fr 0fr'};
	gap: ${(props) =>
		props.isActive || props.ofertasNumber === 1 ? '5px' : '0px'};
`;

// animación de altura dinámica con CSS Grid
export const CollapsibleSection = styled.div<{ isOpen: boolean }>`
	display: grid;
	grid-template-rows: ${(props) => (props.isOpen ? '1fr' : '0fr')};
	transition: grid-template-rows 0.35s cubic-bezier(0.25, 1, 0.5, 1);
	width: 100%;

	& > div {
		min-height: 0;
		visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
		opacity: ${(props) => (props.isOpen ? 1 : 0)};
		transition:
			opacity 0.25s ease,
			visibility 0.25s ease;
	}
`;

export const StyledText = styled(Text as any)`
	transition: font-size 0.25s ease;
`;

export const StyledTextSingleLine = styled(StyledText)`
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: pre;
`;

export const DGTStickerContainer = styled.div<{ isActive: boolean }>`
	opacity: ${(props) => (props.isActive ? 1 : 0)};
	transition: opacity 0.25s ease;
`;

export const CardControllers = styled.div`
	text-align: right;
	min-width: 0;
	overflow: hidden;
`;

export const OpenLayerCTAContainer = styled.div<{ isActive: boolean }>`
	align-self: start;

	opacity: ${(props) => (props.isActive ? 1 : 0)};
	pointer-events: ${(props) => (props.isActive ? 'auto' : 'none')};

	transition: opacity 0.35s ease;
`;
